import SummaryStep from "components/steps/SummaryStep";

const Step8Pages = () => <SummaryStep />;

export default Step8Pages;
